import { render } from "./templateCheque.vue?vue&type=template&id=6d4c2118&scoped=true"
import script from "./templateCheque.vue?vue&type=script&lang=js"
export * from "./templateCheque.vue?vue&type=script&lang=js"

import "./templateCheque.vue?vue&type=style&index=0&id=6d4c2118&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4c2118"]])

export default __exports__